import { createFileRoute } from "@tanstack/react-router";
import { Dashboard } from "@/dashboard/components/Dashboard";
import { PageHeader } from "@/components/PageHeader";

export const Route = createFileRoute("/_auth/dashboard")({
  component: About,
});

function About() {
  return (
    <>
      <PageHeader title="Dashboard" />
      <main className="h-full overflow-y-auto bg-slate-100 p-6">
        <Dashboard />
      </main>
    </>
  );
}
